const qtyInputs = document.querySelectorAll('.cart__item-qty');
qtyInputs.forEach(qtyInput => {
    qtyInput.addEventListener('change', event => {
        const submitUpdate = document.querySelector('#cart__submit-update');
        if (submitUpdate) {
            submitUpdate.click();
        }
    });
});
